/**
 * ImpostorGamePagehandler.js
 * 
 * The first and foremost page of the game
 * Controls the following pages, needed to appear
 * 
 * 
 * Has different pages for the people to view.
 * 1. Select Room page (sessionID = ''); users can start a new room.
 * 
 * GAME RULES
 *  -   This game has {x} number of impostors within {x+y} number of people
 *  -   Impostors know each other from the beginning, the crew mates do not
 *  -   There are 3 ROUNDS (as of now) in the game, where the impostors try to sabotage them, while crew mates want them to pass
 *  -   Teams are divided, according to the discussion and tasks are completed.
 * 
 *  WINNING AGENDA
 *  -   If the impostors are able to sabotage the missions, they win
 *  -   Otherwise the crewmates win
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { useClientAuth } from "../../hooks/clientAuth";
import RoomEntryBox from "../../Rooms/components/RoomEntryBox";
import { TrustIssuesRoomCollection } from "../../assets/DatabaseCollections";

const ImpostorGamePageHandler = () => {
    const { user } = useClientAuth();
    const navigate = useNavigate();

    const setRoom = async (room) => {
        navigate(`/trust-issues/${room}`);
    }

    if (!user) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-black text-zinc-100">
                <p className="text-lg font-medium">Please login first to continue.</p>
            </div>
        );
    }

    return (
        <div className={`min-h-screen flex flex-col items-center justify-center bg-black`}>
            <RoomEntryBox setRoom={setRoom} user={user} dbCollection={TrustIssuesRoomCollection} gameName="Trust Issues" />
        </div>
    );
};

export default ImpostorGamePageHandler;